var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"uk-table uk-table-middle uk-table-striped uk-table-small uk-table-responsive uk-text-small"},[_c('thead',[_vm._t("columnHeaders")],2),_c('tbody',[_vm._t("rowData")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }